import * as React from "react";
const SvgVorherigeSeite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="VorherigeSeite">
    <path
      fill="currentColor"
      d="M215.88 219.69V36.31c0-6.27-6.79-10.19-12.22-7.06L44.85 120.94c-5.43 3.14-5.43 10.98 0 14.11l158.8 91.69c5.43 3.14 12.22-.78 12.22-7.06Zm-15-11.87L62.62 128l138.26-79.82z"
    />
  </svg>
);
export default SvgVorherigeSeite;
